import { TaskType } from '@griply/types';

type HabitOrRepeatingType = TaskType.Habit | TaskType.Repeating;

// Habits and repeating tasks are the schedule-driven kinds; everything else is a to-do with a single date.
export const isHabitOrRepeatingTask = <T extends { type: TaskType }>(
  task: T,
): task is T & { type: HabitOrRepeatingType } =>
  task.type === TaskType.Habit || task.type === TaskType.Repeating;
